export function dashboardOnboardingItemTemplate($templateCache) {
    'ngInject'
    const path = "/Scripts/Page/Home/apex-dashboard-item-template-onboarding.html";
    const html = '<apex-onboarding-dashboard-container></apex-onboarding-dashboard-container>';
    $templateCache.put(path, html);
}

export function dashboardOnboardingListItemTemplate($templateCache) {
    'ngInject'
    const path = "/Scripts/Page/Home/apex-dashboard-list-item-template-onboarding.html";
    const html = `<p ng-if="dashboard.count === 0">No pending onboarding tasks from Herb-Joy at this time.</p>
        <p ng-if="dashboard.count > 0">
            You must finish onboarding in order to continue using the site.
        </p>`;
    $templateCache.put(path, html);
}
